import { withTranslation, WithTranslation } from 'react-i18next';
import React, { ChangeEvent, useEffect, useState } from 'react';
import getRegisterReasons, { IRegisterReason } from '../../../../helpers/registerReasons';
import i18n from 'i18next';
import { ReactComponent as NotificationLogo } from '../../../../styles/img/icons/error.svg';
import { OrganizationStep1FormResultKeys } from './organizationStep1FormModel';
import { IAccountModel } from '../../../../helpers/models/accountModel';
import InputField from '../../../form/inputField';
import DropDownField from '../../../form/dropdownField';

export interface IOrganizationStep1ReasonsProps extends WithTranslation {
    readonly?: boolean;
    account: IAccountModel;
}

const OrganizationStep1Reasons = (props: IOrganizationStep1ReasonsProps) => {
    const { t, readonly, account } = props;
    const [reasonValue, setReasonValue] = useState<any>(account?.reason || '');
    const [otherReasonValue, setOtherReasonValue] = useState<any>(account?.reasonOther || '');

    const handleReasonChange = (e: ChangeEvent<HTMLSelectElement>) => {
        setReasonValue(e.target.value);
        const element = document.getElementById(
            OrganizationStep1FormResultKeys.REASON_OTHER
        )! as HTMLInputElement;
        document.getElementById('registration_reason_other_container')!.style.display =
            e.target.value === 'Other' ? 'unset' : 'none';
        if (e.target.value === 'Other') {
            element.setAttribute('required', '');
        } else {
            element.removeAttribute('required');
            element.value = '';
        }
    };

    useEffect(() => {
        const element = document.getElementById(
            OrganizationStep1FormResultKeys.REASON_OTHER
        )! as HTMLInputElement;

        document.getElementById('registration_reason_other_container')!.style.display =
            element.value ? 'unset' : 'none';
    }, []);

    const registerReasons = getRegisterReasons(i18n.language).map((item: IRegisterReason) => {
        return (
            <option key={item.name} value={item.value}>
                {item.name}
            </option>
        );
    });

    return (
        <>
            <h2
                className="header-3 header-3--purple registration_form_header"
                id="form_organization_step_1_reason_title"
            >
                {t('form_organization_step_1_reason_title')}
            </h2>
            <div className="registration-column-container">
                <div className="field-container registration-organization-information-container registration-organization-reason-container">
                    <DropDownField
                        fieldName={OrganizationStep1FormResultKeys.REASON}
                        fieldContainerClassName="form-organization-reason-field"
                        fieldTitle=""
                        defaultValue={reasonValue}
                        handleOnChange={handleReasonChange}
                        fieldDisabled={readonly}
                        fieldRequired
                        fieldDefaultValue="form_organization_step_1_register_reason_default"
                        fieldOptions={registerReasons}
                        fieldWeight={4}
                        fieldHiddenLabel="form_organization_step_1_reason_title"
                        aria-labelledby="form_organization_step_1_reason_title"
                    />
                    <NotificationLogo
                        id={'form_organization_step_1_register_reason_error_logo'}
                        className="field-error-icon field-error-icon--dropdown"
                    />
                </div>
                <div id="registration_reason_other_container" className="field-container">
                    <InputField
                        type="text"
                        fieldTitle="form_organization_step_1_field_reason_other"
                        fieldName={OrganizationStep1FormResultKeys.REASON_OTHER}
                        fieldDisabled={readonly}
                        defaultValue={otherReasonValue}
                        onChange={(e) => setOtherReasonValue(e.target.value)}
                        fieldWeight={4}
                        fieldHiddenLabel="form_organization_step_1_reason_title"
                        aria-label={t('form_organization_step_3_reason_other_aria_label', {
                            ns: 'accessibility',
                        })}
                    />
                </div>
            </div>
        </>
    );
};

export default withTranslation()(OrganizationStep1Reasons);
